import React from 'react';
import { useScript } from '../modules/useScript';

function CookieBanner() {
    useScript(
        '//consent.truste.com/notice?domain=nandos.co.uk&js=nj&noticeType=bb&gtm=1'
    );

    return <div id='consent_blackbar' />;
}

function openCookiePreferencesModal(e) {
    e.preventDefault();
    e.stopPropagation();

    const trustARC = window.truste && window.truste.eu;

    if (trustARC) {
        trustARC.clickListener();
    }
}

export { CookieBanner, openCookiePreferencesModal };
